/**
 * Indian States and Union Territories with Official GST State Codes
 */
export const INDIAN_STATES = [
  { code: '01', name: 'Jammu & Kashmir' },
  { code: '02', name: 'Himachal Pradesh' },
  { code: '03', name: 'Punjab' },
  { code: '04', name: 'Chandigarh' },
  { code: '05', name: 'Uttarakhand' },
  { code: '06', name: 'Haryana' },
  { code: '07', name: 'Delhi' },
  { code: '08', name: 'Rajasthan' },
  { code: '09', name: 'Uttar Pradesh' },
  { code: '10', name: 'Bihar' },
  { code: '11', name: 'Sikkim' },
  { code: '12', name: 'Arunachal Pradesh' },
  { code: '13', name: 'Nagaland' },
  { code: '14', name: 'Manipur' },
  { code: '15', name: 'Mizoram' },
  { code: '16', name: 'Tripura' },
  { code: '17', name: 'Meghalaya' },
  { code: '18', name: 'Assam' },
  { code: '19', name: 'West Bengal' },
  { code: '20', name: 'Jharkhand' },
  { code: '21', name: 'Odisha' },
  { code: '22', name: 'Chhattisgarh' },
  { code: '23', name: 'Madhya Pradesh' },
  { code: '24', name: 'Gujarat' },
  { code: '26', name: 'Dadra & Nagar Haveli and Daman & Diu' },
  { code: '27', name: 'Maharashtra' },
  { code: '29', name: 'Karnataka' },
  { code: '30', name: 'Goa' },
  { code: '31', name: 'Lakshadweep' },
  { code: '32', name: 'Kerala' },
  { code: '33', name: 'Tamil Nadu' },
  { code: '34', name: 'Puducherry' },
  { code: '35', name: 'Andaman & Nicobar Islands' },
  { code: '36', name: 'Telangana' },
  { code: '37', name: 'Andhra Pradesh' },
  { code: '38', name: 'Ladakh' },
  { code: '97', name: 'Other Territory' }
];

/**
 * Normalizes state string for reliable comparison
 */
export const normalizeState = (stateStr) => {
  if (!stateStr) return '';
  return stateStr
    .toString()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]/g, '')
    .trim();
};

/**
 * Gets state details from a 2-digit GST state code
 */
export const getStateByCode = (code) => {
  if (!code) return null;
  const formattedCode = code.toString().padStart(2, '0');
  return INDIAN_STATES.find(s => s.code === formattedCode) || null;
};

/**
 * Gets state details from a state name
 */
export const getStateByName = (name) => {
  if (!name) return null;
  const norm = normalizeState(name);
  return INDIAN_STATES.find(s => normalizeState(s.name) === norm) || null;
};

/**
 * Extracts 2-digit state code and state name from GSTIN
 */
export const getStateFromGSTIN = (gstin) => {
  if (!gstin || typeof gstin !== 'string' || gstin.trim().length < 2) {
    return null;
  }
  const code = gstin.trim().substring(0, 2);
  const match = getStateByCode(code);
  if (match) {
    return match;
  }
  return null;
};

/**
 * Determines whether the transaction between business and customer is Inter-state (IGST) or Intra-state (CGST + SGST)
 * @param {string} supplierStateOrGSTIN - Business state name or business GSTIN
 * @param {string} customerStateOrGSTIN - Customer state name or customer GSTIN
 * @returns {boolean} true for Inter-state (IGST), false for Intra-state (CGST+SGST)
 */
export const isInterstateTransaction = (supplierStateOrGSTIN, customerStateOrGSTIN) => {
  if (!supplierStateOrGSTIN || !customerStateOrGSTIN) {
    return false; // Default to intrastate if either is unspecified
  }

  // Check if either is a GSTIN (>= 2 chars starting with digits)
  const supplierGSTMatch = getStateFromGSTIN(supplierStateOrGSTIN);
  const supplierState = supplierGSTMatch ? supplierGSTMatch.name : supplierStateOrGSTIN;

  const customerGSTMatch = getStateFromGSTIN(customerStateOrGSTIN);
  const customerState = customerGSTMatch ? customerGSTMatch.name : customerStateOrGSTIN;

  const normSupplier = normalizeState(supplierState);
  const normCustomer = normalizeState(customerState);

  if (!normSupplier || !normCustomer) {
    return false;
  }

  return normSupplier !== normCustomer;
};

export default {
  INDIAN_STATES,
  normalizeState,
  getStateByCode,
  getStateByName,
  getStateFromGSTIN,
  isInterstateTransaction
};
